export default __webpack_public_path__ + "d881a1d740d0626d0630f18de8f0b5ee.png";